export class ContactDamage {
    public damage: number;

    constructor(damage: number) {
        this.damage = damage;
    }
}
